module.exports = __webpack_public_path__ + "media/images/impact-report-responsible-consumption-d3360baf5738c38a86e299a4ac9ee793.png";